import React from "react";
import { AppBar, Tabs, Tab, Divider } from "@material-ui/core";

const NavigationTabs = ({ tabValue, setQuery, t }) => {
  const a11yProps = (index) => ({
    id: `nlp-tab-${index}`,
    "aria-controls": `nlp-tabpanel-${index}`,
  });

  return (
    <>
      <AppBar id="app_bar" position="static" color="default">
        <Tabs
          value={tabValue}
          variant="scrollable"
          scrollButtons="on"
          textColor="primary"
        >
          <Tab
            label={t("header.title.intents")}
            onClick={(e) => setQuery(e, "intents")}
            {...a11yProps(0)}
          />
          <Tab
            label={t("header.title.contexts")}
            onClick={(e) => setQuery(e, "contexts")}
            {...a11yProps(1)}
          />
          <Tab
            label={t("header.title.entities")}
            onClick={(e) => setQuery(e, "entities")}
            {...a11yProps(2)}
          />
        </Tabs>
        <Divider />
      </AppBar>
    </>
  );
};

export default NavigationTabs;
